<section class="panel" [class.headerless]="hideHeader">
  @if (!hideHeader) {
    <header class="panel-header">
      <div>
        <p class="eyebrow">Structure</p>
        <h3>Landing page parts</h3>
      </div>
    </header>
  }

  <div class="block-list">
    @for (block of blocks; track $index; let blockIndex = $index) {
      <div class="insert-row">
        <button
          type="button"
          class="insert-button"
          aria-label="Add block here"
          (click)="openBlockTypeDialog(blockIndex)">
          +
        </button>
      </div>

      <section class="block-card">
        <div class="block-toolbar">
          <div>
            <span class="block-index">{{ blockIndex + 1 }}</span>
            <strong>{{ block.type }}</strong>
          </div>
          <div class="toolbar-actions">
            <button type="button" class="ghost small" (click)="moveBlock(blockIndex, -1)">Up</button>
            <button type="button" class="ghost small" (click)="moveBlock(blockIndex, 1)">Down</button>
            <button type="button" class="danger small" (click)="removeBlock(blockIndex)">Remove</button>
          </div>
        </div>

        @switch (block.type) {
          @case ('heading') {
            <cms-landing-page-heading-block-editor [block]="block" (blockChange)="updateBlock(blockIndex, $event)" />
          }
          @case ('text') {
            <cms-landing-page-text-block-editor [block]="block" (blockChange)="updateBlock(blockIndex, $event)" />
          }
          @case ('image') {
            <cms-landing-page-image-block-editor
              [block]="block"
              [availableImages]="availableImages"
              (blockChange)="updateBlock(blockIndex, $event)" />
          }
          @case ('gallery') {
            <cms-landing-page-gallery-block-editor
              [block]="block"
              [availableGalleries]="availableGalleries"
              (blockChange)="updateBlock(blockIndex, $event)" />
          }
          @case ('youtubevideo') {
            <cms-landing-page-youtube-block-editor [block]="block" (blockChange)="updateBlock(blockIndex, $event)" />
          }
          @case ('codeblock') {
            <cms-landing-page-code-block-editor [block]="block" (blockChange)="updateBlock(blockIndex, $event)" />
          }
          @case ('references') {
            <cms-landing-page-references-block-editor [block]="block" (blockChange)="updateBlock(blockIndex, $event)" />
          }
        }
      </section>
    } @empty {
      <div class="empty-insert">
        <button
          type="button"
          class="insert-button"
          aria-label="Add first block"
          (click)="openBlockTypeDialog(0)">
          +
        </button>
        <p class="empty">No content blocks yet.</p>
      </div>
    }

    @if (blocks.length > 0) {
      <div class="insert-row">
        <button
          type="button"
          class="insert-button"
          aria-label="Add block at end"
          (click)="openBlockTypeDialog(blocks.length)">
          +
        </button>
      </div>
    }
  </div>
</section>

@if (insertionIndex !== null) {
  <div class="dialog-backdrop" (click)="closeBlockTypeDialog()">
    <section
      class="dialog-panel block-type-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-block-title"
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <div>
          <p class="eyebrow">Structure</p>
          <h2 id="add-block-title">Add block</h2>
        </div>
        <button type="button" class="ghost small" (click)="closeBlockTypeDialog()">Close</button>
      </header>

      <div class="block-type-grid">
        @for (type of blockTypes; track type) {
          <button type="button" class="ghost block-type-option" (click)="insertBlock(type)">
            {{ type }}
          </button>
        }
      </div>
    </section>
  </div>
}
